import type { FunctionComponent } from 'react';

/**
 * Generic FOSSA Paragraph text, wrapped in a <p> tag.
 *
 * @param {React.ReactNode} children - The text to display
 */
const Paragraph: FunctionComponent = ({ children }) => (
  <p className="fossa-text fossa-text__paragraph">
    {children}
  </p>
);

export default Paragraph;
